'use memo';

import { Outlet, useLocation } from 'react-router-dom';
import LoadingState from 'components/loadingState/LoadingState';
import { MenuTitles, Pages } from 'constants/menu';
import { useSelectedContract } from 'hooks';
import { ContractSubPage } from '../ContractSubPage';
import { ContractInformationLockedState } from './ContractInformationLockedState';
import { getContractInformationSubPages } from './ContractInformationSubPages';
import { isContractInformationUnlocked } from './contractInformationAccess';

const contractInformationPages = new Set<Pages>([
  Pages.SALE_INFORMATION,
  Pages.CONDITIONS,
  Pages.SPECIAL_CONDITIONS,
  Pages.SETTLEMENT,
  Pages.DEPOSITS,
]);

function getCurrentContractInformationPage(pathname: string): Pages {
  const page = pathname.split('/').filter(Boolean).at(-1) as Pages | undefined;

  return page && contractInformationPages.has(page) ? page : Pages.SALE_INFORMATION;
}

const ContractInformationLayout = () => {
  const location = useLocation();
  const { contract, isLoading } = useSelectedContract();

  if (isLoading) return <LoadingState />;

  if (isContractInformationUnlocked(contract?.contractStage)) {
    return <Outlet />;
  }

  return (
    <ContractSubPage
      pageTitle="Contract Information"
      secondaryActiveMenu={MenuTitles.CONTRACT_INFORMATION}
      currentPage={getCurrentContractInformationPage(location.pathname)}
      subPages={getContractInformationSubPages({ locked: true })}
      onSaveChanges={() => {}}
      isFormDirty={false}
      isSaving={false}
      isError={false}
      hideSaveButton
    >
      <ContractInformationLockedState />
    </ContractSubPage>
  );
};

export default ContractInformationLayout;
